import classNames from "classnames"
import type { ReactNode } from "react"

export interface Props {
  variant: "white" | "lightBlue"
  children: ReactNode
  icon?: ReactNode
  className?: string
}

const Tag = ({ variant, children, icon, className }: Props) => {
  return (
    <span
      className={classNames(
        "inline-flex rounded-full px-3 md:px-4 py-[0.45rem] text-[11px] md:text-sm font-medium uppercase",
        {
          "items-center gap-1.5": !!icon,
          "bg-white text-gray-300": variant === "white",
          "bg-blue-light-25 text-blue-dark-500": variant === "lightBlue"
        },
        className
      )}
    >
      {icon && <span>{icon}</span>}
      {children}
    </span>
  )
}

Tag.displayName = "Tag"

export { Tag }
export default Tag
